<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="notification is-info" v-if="salvandoDados">
                    <button class="delete"></button>
                    A condição de pagamento de exame está sendo salva, este processo pode levar alguns minutos.
                </div>

                <div class="tile is-ancestor">
                    <div class="tile is-parent is-vertical is-9">
                        <article class="tile is-child box">
                            <div class="columns">
                                <div class="column is-two-thirds">
                                    <ValidationProvider rules="required" name="model.descricao" v-slot="{ errors, valid }">
                                        <b-field label="Descrição"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" v-model="model.descricao"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-two-thirds">
                                    <ValidationProvider name="model.especieDePagamento" v-slot="{ errors, valid }">
                                        <b-field label="Espécie de Pagamento"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-select placeholder="Selecione a Espécie" v-model="model.especieDePagamento">
                                                <option value=""></option>
                                                <option v-for="option in model.especies"
                                                        :value="option.id"
                                                        :key="option.id">
                                                    {{ option.nome }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-one-third">
                                    <ValidationProvider rules="required" name="model.qtdeParcelas" v-slot="{ errors, valid }">
                                        <b-field label="QtdeParcelas"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="text" v-model="model.qtdeParcelas"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-two-thirds">
                                    <ValidationProvider name="model.bandeira" v-slot="{ errors, valid }">
                                        <b-field label="Bandeira"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-select placeholder="Selecione a Bandeira" v-model="model.bandeira.id">
                                                <option v-for="bandeira in model.bandeiras"
                                                        :key="bandeira.id"
                                                        :value="bandeira.id">
                                                    {{ bandeira.nome }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column is-one-third">
                                    <ValidationProvider name="model.prazoVencimento" v-slot="{ errors, valid }">
                                        <b-field label="Prazo de Vencimento"
                                                 :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                 :message="errors">
                                            <b-input type="number" v-model="model.prazoVencimento"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </article>
                    </div>   
                    <div class="tile is-parent">
                        <article class="tile is-child">
                            <historico-alteracoes :tabela="'CondicaoPagamento'" :chave="model.id"></historico-alteracoes>
                        </article>
                    </div>                 
                </div>
                <nav class="level">
                    <div class="level-item">
                        <p class="buttons">
                            <b-button type="is-success" v-show="isInRole('condicaopagamento-alterar')"
                                      :loading="salvandoDados"
                                      native-type="submit"
                                      icon-left="check-circle">
                                Salvar
                            </b-button>
                            <b-button type="is-danger"
                                      native-type="button"
                                      icon-left="close-circle"
                                      @click="$router.back();">
                                Cancelar
                            </b-button>
                        </p>
                    </div>
                </nav>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import historicoAlteracoes from '@/components/historicoAlteracoes.vue'

    export default {
        components: {
            titlebar,
            historicoAlteracoes
        },
        data() {
            return {
                model: {
                    id: null,
                    descricao: null,
                    bandeiras: [],
                    especies: [],
                    bandeira: null,
                    especieDePagamento: null,
                    qtdeParcelas: null,
                    prazoVencimento: null
                },
                salvandoDados: false
            }
        },
        created() {
            let url = '/api/manutencao/condicaopagamento';
            if (this.$route.params.id > 0){
                url = '/api/manutencao/condicaopagamento?id=' + this.$route.params.id;
            }
            this.$http.get(url)
                .then(res => {
                    this.model = res.data;
                });
        },
        computed: {
            titleStack() {
                return [
                    'Manutenção',
                    'Condição de Pagamento',
                    this.model.id ?? 'novo'
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
            onSubmit() {
                this.salvandoDados = true;
                this.$http.post(`/api/manutencao/condicaopagamento`, this.model)
                    .then(() => {
                        this.salvandoDados = false;
                        this.$router.back()
                    })
                    .catch((error) => {
                        this.salvandoDados = false;
                        throw error
                    });
            }
        }
    }
</script>